import styled from '@emotion/styled/macro';
import { TableWrapper } from '../../../../common/SideBySideTableLayout/SideBySideTableLayout.styles';
import rem from '../../../../utils/rem/rem';

export const StyledTableWrapper = styled(TableWrapper)`
  height: 60vh;
`;

export const SelectRawProdsContainer = styled.div`
  margin: 0 32px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  padding-top: ${rem(16)};
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: ${rem(16)};
`;